// Central content + shared assets for DVG Sports

export const LOGO_MARK = "/logo-mark-white.png";
export const LOGO_WORDMARK = "/logo-wordmark-white.png";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1726195221775-e1d394a19f02?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  manifesto: "https://images.unsplash.com/photo-1618566105831-d604c45a7316?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  handshake: "https://images.unsplash.com/photo-1681505526188-b05e68c77582?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  stadium: "https://images.unsplash.com/photo-1489944440615-453fc2b6a9a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  staffHero: "https://images.unsplash.com/photo-1489944440615-453fc2b6a9a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const SERVICES = [
  {
    n: "01",
    title: "Contract Negotiation",
    body: "Aggressive, data-backed negotiation across NIL and professional contracts — maximizing guarantees, incentives and protection for every client.",
  },
  {
    n: "02",
    title: "Client Services",
    body: "Relationship-driven, day-to-day support for athletes and families. Communication, organization and personal attention at every stage of the journey.",
  },
  {
    n: "03",
    title: "Brand Partnerships & NIL",
    body: "Athlete branding, endorsements, NIL deals and strategic brand partnerships — engineered to turn talent and work ethic into lasting brand equity on and off the field.",
  },
  {
    n: "04",
    title: "Training",
    body: "Preparation and development resources that keep athletes ready to perform and positioned to compete at the highest level.",
  },
  {
    n: "05",
    title: "Business Set-Up",
    body: "Business infrastructure and entity setup — helping athletes build enterprises that endure well beyond the playing career.",
  },
  {
    n: "06",
    title: "Tax Prep",
    body: "Financial structure and tax preparation by trusted CPAs that protect earnings and secure the future for athletes and their families.",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    kicker: "The Mindset",
    title: "David never blinked.",
    body: "We were built on a David vs. Goliath belief: the underdog with conviction, preparation and heart beats the giant every time. We bring that relentless mindset to every deal, for every athlete, every day.",
  },
  {
    n: "02",
    kicker: "The Business",
    title: "Win the business of sports.",
    body: "Talent gets you drafted. Strategy keeps you wealthy. We treat representation as a business discipline — sharp negotiation, real numbers and decisions that compound value over a lifetime.",
  },
  {
    n: "03",
    kicker: "The Family",
    title: "We protect what matters.",
    body: "Athletes don't win alone. We stand with families — guiding, shielding and advising — so the people who sacrificed the most share in the reward and the security.",
  },
];

export const STATS = [
  { value: "$8M+", label: "Deals Closed In 2025" },
  { value: "10+", label: "Team & Partners" },
  { value: "3", label: "Power Programs" },
  { value: "100%", label: "Family First" },
];

// Real DVG Sports team. Add an `image` URL per person when headshots are ready.
export const STAFF = [
  {
    name: "Jordan Arcement",
    role: "Agent & CEO",
    category: "Leadership",
    image: "/team/jordan.png",
    bio: "Jordan brings nearly a decade of college football experience as a former Nicholls State athlete and high-school coach. He built his recruiting expertise at Virginia, rising to Director of Recruiting Communications before moving into NIL — building an athlete-marketing company, partnering with Shock Doctor nationally, launching a 7v7 circuit, and serving as executive producer of \"Blue Chippers: Next Man Up\" (Prime Video, Apple TV). He was the first to execute NIL for LSU Football, helping launch the Tigers' collective, then moved to the player side with Athletes First. He founded DVG Sports on a commitment to informed, relationship-driven representation — personally closing more than $8 million in deals in the 2025 cycle alone.",
  },
  {
    name: "Faith Abraham",
    role: "CFO",
    category: "Leadership",
    image: "/team/faith.png",
    bio: "A Fractional CFO and operational strategist working at the intersection of finance, systems and growth. Known for her work with Caroline's Cookies — where her financial infrastructure helped scale the company from a home kitchen into a multi-location brand — Faith evaluates financial health, refines workflows and builds scalable systems, giving DVG the structure and oversight for long-term performance.",
  },
  {
    name: "Ley McFadden",
    role: "Director of Client Relations",
    category: "Client & Marketing",
    image: "/team/ley.png",
    bio: "Ley's experience spans three major programs and multiple levels of athlete development. She served as Director of Recruiting at Arkansas State, worked in recruiting operations at Purdue, and interned within the NIL division of CAA. That blend of collegiate recruiting, operations and agency-side NIL makes her uniquely equipped to support DVG athletes and families — leading client relations with communication, organization, guidance and personal attention.",
  },
  {
    name: "Daja Maxey",
    role: "Director of Marketing",
    category: "Client & Marketing",
    image: "/team/daja.png",
    bio: "An LSU Sports Administration graduate with experience across LSU Athletics Marketing & Communications, Men's Basketball and Football Operations. Daja specializes in athlete branding, strategic partnerships and business development — building authentic, long-term relationships between athletes, brands and partners. She's passionate about breaking the stigma around men's mental health, expanding opportunities for women in sports, and developing the next generation of athlete leaders.",
  },
  {
    name: "A’Tiah Bernard",
    role: "Manager of Brand & Talent Outreach, Basketball",
    category: "Client & Marketing",
    image: "/team/atiah.jpg",
    bio: "An LSU Sports Administration graduate with experience across LSU Women's Basketball Recruiting, LSU Football, NILSU and LSU Sports Media. A'Tiah specializes in athletic branding and sports media, leveraging her creative talent to develop impactful content, elevate athletes' personal brands and build meaningful relationships within the sports industry. She's passionate about creating leverage and opportunities for athletes through her work, helping them recognize and maximize their value beyond the game. A'Tiah is also passionate about sports psychology and creating a safe, supportive and mentally healthy environment where athletes can grow, perform and thrive both on and off the field.",
  },
  {
    name: "Ayden Collins",
    role: "Agent",
    category: "Agents",
    image: "/team/ayden.png",
    bio: "An NIL Agent bringing a business & entrepreneurial background with negotiation experience and a deep understanding of the football landscape. The son of a football coach, Ayden developed an early appreciation for the relationships and preparation the game demands. He gained insight into representation through the agent vetting process with current NFL players, then worked independently in NIL before joining DVG to expand the resources available to his athletes.",
  },
  {
    name: "Jerry Mitchell",
    role: "Agent",
    category: "Agents",
    image: "/team/jerry.png",
    bio: "An NIL Agent with a diverse background in athletics, business and financial management. After helping guide a highly recruited athlete through the recruiting and NIL process, Jerry began representing athletes independently — building expertise in recruiting, NIL, athlete development and family guidance. His experience in real estate, management and automotive finance lets him approach representation from both a personal and business perspective.",
  },
  {
    name: "Zack West",
    role: "Agent, Basketball",
    category: "Coaching",
    image: "/team/zack.jpg",
    bio: "Zack's experience spans multiple levels of basketball as a player, coach, trainer, and organizational leader. A 2009 graduate of Redemptorist High School, he continued his playing career at Nicholls State University from 2011–2013 before transitioning into coaching and player development. With 15 years of basketball training experience, Zack has trained and developed more than 100 collegiate and professional athletes, focusing on skill development, fundamentals, performance, and preparation for higher levels of competition. His coaching experience includes three years at St. Joseph's Academy and his current role at St. Michael the Archangel High School, where he is entering his second year. Zack also serves as Head Trainer at Sportsplex and is entering his fourth year as President of I.D.E. Basketball, where he provides leadership and direction while overseeing player development and basketball programming. His combination of collegiate playing experience, high school coaching, elite-level player development, and organizational leadership allows him to provide athletes and families with experienced guidance throughout their basketball journey.",
  },
  {
    name: "Emma Davis",
    role: "Talent Acquisition Manager, Football",
    category: "Team",
    image: "/team/emma.png",
    bio: "Emma combines experience in event planning with a passion for athletics and football. She plays a key role in athlete recruitment and relationship development — identifying prospective clients and building meaningful connections with athletes and families, bringing strong organizational and communication skills to recruiting and onboarding.",
  },
  {
    name: "Brandon Robinson",
    role: "Strategic Partner",
    category: "Partners",
    image: "/team/brandon.jpg",
    bio: `Brandon Robinson is a Louisiana-based entrepreneur and Managing Partner of Planet Construction J2911, a commercial general contracting company specializing in multi-unit development and national rollout programs for franchisees and growing brands. Licensed and operating in 45 states across the continental United States, Planet Construction serves clients including Planet Fitness, Club 4 Fitness, Caroline's Cookies, Urban Air Adventure Park, Five Below, Burlington, EquipmentShare, McDonald's, Water Wings Swim School, and Christian Brothers Automotive, among others.

Brandon's entrepreneurial interests extend well beyond construction. He is an owner and developer of Urban Air Adventure Park, opening his first location in Lake Charles, Louisiana, in August 2024.

One of the ventures closest to his heart is Caroline's Cookies. Brandon partnered with then-19-year-old founder Caroline Merryman to help transform her rapidly growing cookie business into a brick-and-mortar retail concept, with locations in Lafayette and Baton Rouge. Brandon is quick to credit Caroline as the creative force behind the brand and product, describing her as an exceptional young entrepreneur with the talent and drive to become a powerhouse in the business world.

Prior to Planet Construction, Brandon was a Partner in United PF Partners, which owned and operated 168 Planet Fitness locations across 14 states and, during his tenure, was the largest Planet Fitness franchisee in the country. That experience helped shape his understanding of franchise development, multi-unit operations, construction, and the challenges associated with rapidly scaling businesses across multiple markets.

Brandon's path to entrepreneurship was anything but conventional. Professionally educated and trained as a Certified Registered Nurse Anesthetist (CRNA), he spent approximately 20 years practicing anesthesia, with an emphasis on cardiovascular and neuro-spine procedures. He was also a member of a National Speakers Bureau, completing hundreds of speaking engagements throughout the country as an authority on cardiovascular anesthesia. In December 2018, Brandon retired from clinical practice to devote his career fully to his entrepreneurial endeavors.

Despite the diversity of his career—from healthcare and national speaking to fitness, construction, franchising, and business development—Brandon gives the credit for his journey to his Lord and Savior, Jesus Christ. He describes his story simply as that of an ordinary man who has been blessed to live an extraordinary, supernatural experience through the Grace of God.

Above all, Brandon considers his greatest success to be his family. He is married to his high school sweetheart, Ammie Robinson, and they reside in the Lafayette, Louisiana area, surrounded by their children and grandchildren—the people Brandon considers the true motivation behind everything he does.`,
  },
  {
    name: "Jeff Babineaux",
    role: "Strategic Partner",
    category: "Partners",
    image: "/team/jeff.jpg",
    bio: `Jeff Babineaux brings nearly 30 years of business ownership, leadership, and entrepreneurship to DVG SPORTS, with experience that reaches far beyond any one industry.

Throughout his career, Jeff has built, owned, operated, and invested in businesses across the country. His experience includes serving as a general contractor with operations spanning 45 states, building for some of the nation's most recognized and sought-after franchise brands. His portfolio of experience also includes owning and operating Planet Fitness locations across multiple states, personal training studios, a commercial glazing company, aviation companies, Planet Pipeline, Urban Air Adventure Parks, CC Coffee House, a nationwide real estate portfolio, and a 6,000-acre cattle ranch—just to name a few.

That diversity of experience has given Jeff something that can't be learned from a textbook: a broad, real-world understanding of business, leadership, negotiations, investments, risk, growth, and what it takes to build something that lasts.

But for Jeff, business has never been the ultimate measure of success.

Family comes first. Jeff and his wife have built their life around their family and their three children, and he is quick to tell you that everything he has worked for, built, and accomplished has been for them. They are the reason behind the long hours, the risks, the sacrifices, and the drive to continue building something that will last for generations.

Above all, Jeff gives God the credit for where he is today. He believes the opportunities, relationships, successes, and even the challenges along the way have all played a part in shaping the man, husband, father, and businessman he has become. His faith, family, and belief in leaving something meaningful behind are at the center of everything he does.

That same philosophy is a major part of the vision behind DVG SPORTS.

DVG SPORTS was created to bring a business-minded, relationship-driven approach to athlete representation. Jeff believes an athlete's career should be viewed as more than the next contract or opportunity. It should be treated as a business, a brand, and ultimately a platform capable of creating opportunities, building wealth, and establishing a legacy long after the playing days are over.

With decades of experience building companies, managing teams, negotiating deals, investing in real estate, and creating businesses across multiple industries, Jeff brings a perspective to athletes that reaches well beyond sports. His goal is not simply to represent athletes during their careers, but to help them think bigger about their future, their families, and what they can build with the opportunities they've been given.

The mission is simple: protect the athlete, maximize the opportunity, build the brand, and help create a legacy that lasts beyond the game.`,
  },
  {
    name: "Sports Law & Legal Support",
    role: "Legal & Contract Support",
    category: "Partners",
    image: "/team/legal.jpg",
    bio: "Behind DVG is a trusted network of some of the nation's leading sports attorneys. Their experience across representation, NIL, contracts, revenue sharing, compliance and complex sports-business matters gives DVG another layer of expertise — the resources, perspective and protection to serve athletes and families at the highest level.",
  },
  {
    name: "Financial Advisory & Wealth Partners",
    role: "Investment & Wealth Access",
    category: "Partners",
    image: "/team/finance.jpg",
    bio: "DVG maintains relationships with select high-end financial advisory firms, giving our athletes access to sophisticated wealth management and investment opportunities should they choose to pursue them. From portfolio strategy to long-term wealth preservation, we connect clients with trusted advisors who help transform peak-earning years into lasting financial security for themselves and their families.",
  },
];

export const SPORTS = [
  "Football", "Basketball", "Baseball", "Soccer", "Track & Field", "Other",
];

export const slugify = (s) =>
  s.toLowerCase().replace(/&/g, " and ").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// Team divisions (ordered). Edit member lists to move people between divisions.
export const DIVISIONS = [
  {
    title: "Football Division",
    members: [
      "Jordan Arcement",
      "Faith Abraham",
      "Ley McFadden",
      "Daja Maxey",
      "Ayden Collins",
      "Jerry Mitchell",
      "Emma Davis",
    ],
  },
  {
    title: "Basketball Division",
    members: ["Zack West", "A’Tiah Bernard"],
  },
  {
    title: "Partners",
    members: [
      "Brandon Robinson",
      "Jeff Babineaux",
      "Sports Law & Legal Support",
      "Financial Advisory & Wealth Partners",
    ],
  },
];
